import { useCallback } from "react";
import axios from "axios";
import Config from "../../Constants/Config";
import { useAuthDetails } from "../../Common/cookiesHelper";

/**
 * POST to the Lumana Node endpoints with the panel session.
 *
 * useAuthDetails() builds a fresh object every render, so the callback depends
 * on the primitive fields only — depending on the object would re-create it
 * each render and loop any effect that uses it.
 */
export const useLumanaApi = () => {
  const { userTypeData, LoginGetDashBoardRecordJson } = useAuthDetails();
  const merchantId = LoginGetDashBoardRecordJson?.data?.merchant_id;
  const token = userTypeData?.token;
  const tokenId = userTypeData?.token_id;
  const loginType = userTypeData?.login_type;

  return useCallback(
    async (endpoint, payload = {}, options = {}) => {
      const { data } = await axios.post(
        Config.BASE_NODE_URL + endpoint,
        { merchant_id: merchantId, token_id: tokenId, login_type: loginType, ...payload },
        {
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          signal: options.signal,
        }
      );
      return data;
    },
    [merchantId, token, tokenId, loginType]
  );
};

export * from "./lumanaFormat";
